(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["concept-a-shop-categories"] && !Shopify.designMode) return;
  try {
    
  class ConceptAShopSort extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.grid = this.closest('.concept-a-shop-categories__group').querySelector(
        '.concept-a-shop-categories__grid'
      );
      this.select.addEventListener('change', () => this.sort());
    }

    sort() {
      const items = Array.from(this.grid.children);
      const mode = this.select.value;

      items.sort((a, b) => {
        if (mode === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (mode === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        if (mode === 'alpha') return a.dataset.title.localeCompare(b.dataset.title);
        return Number(a.dataset.position) - Number(b.dataset.position);
      });

      items.forEach((item) => this.grid.appendChild(item));
    }
  }

  customElements.define('concept-a-shop-sort', ConceptAShopSort);

  class ConceptAVariantPicker extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variant-data]').textContent);
      this.selects = Array.from(this.querySelectorAll('select'));
      this.item = this.closest('.concept-a-shop-categories__item');
      this.priceCurrent = this.item.querySelector('[data-price-current]');
      this.priceCompare = this.item.querySelector('[data-price-compare]');
      this.variantInput = this.item.querySelector('[data-variant-id-input]');
      this.addButton = this.item.querySelector('.concept-a-shop-categories__add-to-cart-button');
      this.selects.forEach((select) => select.addEventListener('change', () => this.updateVariant()));
    }

    updateVariant() {
      const match = this.variants.find((variant) =>
        this.selects.every((select) => variant.options[Number(select.dataset.optionIndex)] === select.value)
      );
      if (!match) return;

      this.variantInput.value = match.id;
      this.priceCurrent.textContent = match.price;

      if (match.compareAtPrice) {
        this.priceCompare.textContent = match.compareAtPrice;
        this.priceCompare.hidden = false;
      } else {
        this.priceCompare.hidden = true;
      }

      this.addButton.disabled = !match.available;
      this.addButton.textContent = match.available ? 'add to cart +' : 'sold out';
    }
  }

  customElements.define('concept-a-variant-picker', ConceptAVariantPicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
